export interface SalesOrderCustomer {
  customerAddressMultiLine: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  deliveryAddressId: string;
  deliveryAddressMultiLine: string;
  invoiceAddressId: string;
  invoiceAddressMultiLine: string;
  paymentTermId: string;
  paymentDueDate: Date;
  currencyId: string;
  settlementTermId: string;
  sellingCompanyId: string;
  serviceRepId: string;
  taxId: string;
  vatRegNo: string;
  bankId: string;
  proformaOrder: boolean;
  shipperSupplierId: string;
  portId: string;
  modeOfTransportId: string;
  deliveryTermId: string;
  chargeDelivery: boolean;
  onStop: boolean;
  deliveryAddresseeId: string;
  deliveryAddressee: string;
  invoiceAddresseeId: string;
  invoiceAddressee: string;
  internalNotes: string;
  autoCreditCheck: boolean;
}
